export enum TimesheetStatus {
  New = 'NEW',
  Open = 'OPEN',
  Submitted = 'SUBMITTED',
  Locked = 'LOCKED'
}

export const CORRECT_MONTH_NUMBER = 1;
